// config.js
// Global config for environment variables


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const REACT_APP_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const VIZUALIZER_SDK_URL = process.env.REACT_APP_VIZUALIZER_SDK_URL;
const REACT_APP_VIZUALIZER_API_KEY = process.env.REACT_APP_VIZUALIZER_API_KEY;
const REACT_APP_BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;
const REACT_APP_VIZUALIZER_URL = process.env.REACT_APP_VIZUALIZER_URL;
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_EMAIL_POPUP = process.env.REACT_APP_EMAIL_POPUP;
const REACT_APP_ENGAGEMENT_POPUP = process.env.REACT_APP_ENGAGEMENT_POPUP;


export { API_BASE_URL, REACT_APP_RECAPTCHA_SITE_KEY,VIZUALIZER_SDK_URL, REACT_APP_VIZUALIZER_API_KEY, REACT_APP_BACKEND_API_URL, REACT_APP_VIZUALIZER_URL, REACT_APP_API_URL, REACT_APP_EMAIL_POPUP, REACT_APP_ENGAGEMENT_POPUP };
